import * as React from 'react'
// import { dateFormat } from '../../util'
// import * as moment from 'moment'
import './SearchInput.css'

class SearchInput extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            deleteInput: false,
            inputValue: '',
        }
        this.changeInputStatus = this.changeInputStatus.bind(this)
        this.clearInput = this.clearInput.bind(this)
        this.goToSearch = this.goToSearch.bind(this)
        // this.setBackground = this.setBackground.bind(this)
        this.hideMask = this.hideMask.bind(this)
    }

    // componentDidMount() {
    // }

    changeInputStatus(event: any) {
        if (event.target.value === '') {
            this.setState(
                {
                    deleteInput: false,
                    inputValue: event.target.value
                }
            )
        } else {
            this.setState(
                {
                    deleteInput: true,
                    inputValue: event.target.value
                }
            )
        }
    }
    clearInput() {
        // this.setBackground()
        this.setState(
            {
                deleteInput: false,
                inputValue: ''
            }
        )
        // this.setBackground()
    }
    goToSearch(event: any) {
        if (event.keyCode === 13) {
            const {searchResult} = this.props
            searchResult(event.target.value)
        }
    }
    setBackground() {
        const {setMask} = this.props
        setMask()
    }
    hideMask() {
        const {hideMask} = this.props
        hideMask()
    }
    render() {
        const deleteInput = this.state.deleteInput
        const inputValue = this.state.inputValue
        const {definePlaceholder} = this.props
        return (
            <div className="search-box">
                <div className="magnifier">
                    <i className="fa fa-search" />
                </div>
                <input type="text" className="search-input" autoComplete="off" value={inputValue} placeholder={definePlaceholder} onChange={this.changeInputStatus} onBlur={this.hideMask} onKeyDown={this.goToSearch}/>
                {
                    deleteInput ?
                        <div className="delete-input" onClick={this.clearInput}>
                            <i className="fa fa-close"/>
                        </div>
                        :
                        ''
                }

            </div>
        )
    }
}

export default SearchInput



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SearchInput/index.tsx